import React from 'react';
import { get, keys } from 'lodash';
import { connect } from 'react-redux';
import { CHANGE_CUSTOM_CONTENT_LANGUAGE_CODE, SET_TEXT_VALUE_IN_CONFIG } from '../../../constants/ActionTypes';
import { ControlledSelect as Select } from '../../../components/ui/sabre-spark-react-ex';
import ReactSparkTextInput from '../../widgets/ReactSparkTextInput';
import { checkPermissionForLevel } from '../../../../lib/utils';
import { ACCESS_POINTS_GROUP, ACCESS_POINT_LEVEL } from '../../../constants/AccessPoints';

const POLICY_URL_HEADER_MAP = {
    optIn: 'Checkout Page Opt In Policy URL',
    privacy: 'Checkout Page Privacy Policy URL',
    bookingConditions: 'Checkout Page Booking Conditions URL',
    signUp: 'Checkout Page Profile Creation URL',
    profileOptIn: 'Sign Up Page Opt In Policy URL',
    profilePrivacy: 'Sign Up Page Privacy Policy URL',
    profileSignUp: 'Sign Up Page Profile Creation URL',
    psdCompliance: 'Guest Consent to Store Card Data Policy URL'
};

const PagesPolicyUrls = ({
    changeCustomContentLanguageCode,
    currentConfigCopy,
    languageCode,
    languageList = [],
    permissionEdit,
    setConfigText
}) => {
    const languageOptionsList = languageList.map(language => ({
        key: language.code,
        label: language.name
    }));
    const policyUrlHeaders = keys(POLICY_URL_HEADER_MAP);

    return (
        <div className="ThemeColors Theme-Content spark-mar-t-1">
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>
                    <h1>Policy Urls</h1>
                </span>
            </div>
            <div className="subpages-main-content">
                <div className="spark-panel spark-margin-top">
                    <div className="spark-panel__content">
                        <div className="row">
                            <div className="col-xs-4">
                                <Select
                                    label="Select a Language"
                                    value={languageCode}
                                    options={languageOptionsList}
                                    onChange={value => {
                                        changeCustomContentLanguageCode(value);
                                    }}
                                    className="col-xs-7 spark-mar-b-2"
                                />
                                {policyUrlHeaders.map((header, idx) => (
                                    <div key={idx}>
                                        <h4>{get(POLICY_URL_HEADER_MAP, header)}</h4>
                                        <ReactSparkTextInput
                                            label="Title"
                                            name="theme-name"
                                            value={get(
                                                currentConfigCopy,
                                                `policyUrls.${languageCode}.${header}.title`,
                                                ''
                                            )}
                                            isDisabled={!permissionEdit}
                                            onChange={event => {
                                                setConfigText(
                                                    `policyUrls.${languageCode}.${header}.title`,
                                                    event.target.value
                                                );
                                            }}
                                        />
                                        <ReactSparkTextInput
                                            label="URL"
                                            name="theme-name"
                                            value={get(
                                                currentConfigCopy,
                                                `policyUrls.${languageCode}.${header}.url`,
                                                ''
                                            )}
                                            isDisabled={!permissionEdit}
                                            onChange={event => {
                                                setConfigText(
                                                    `policyUrls.${languageCode}.${header}.url`,
                                                    event.target.value
                                                );
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        customContent: state.app.data.theme.customContent.customContent,
        currentConfigCopy: state.app.data.configuration.configuration.currentConfigCopy,
        languageCode: state.app.data.configuration.configuration.customContentLanguageCode,
        languageList: state.app.selected.languageList,
        defaultLanguageCode: state.app.selected.defaultCode,
        permissionEdit: checkPermissionForLevel(
            state.oauth.accessLevel,
            ACCESS_POINTS_GROUP.CONFIGURATION,
            ACCESS_POINT_LEVEL.EDIT,
            state.oauth.userPermissionLevels,
            state.app.selected.level
        )
    };
};

const mapDispatchToProps = dispatch => ({
    changeCustomContentLanguageCode: code => {
        dispatch({ type: CHANGE_CUSTOM_CONTENT_LANGUAGE_CODE, languageCode: code });
    },
    setConfigText: (code, value) => {
        dispatch({ type: SET_TEXT_VALUE_IN_CONFIG, code: code, value: value });
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(PagesPolicyUrls);



// WEBPACK FOOTER //
// ./src/components/pages/pages/PagesPolicyUrls.js